module.exports = __webpack_public_path__ + "static/media/09.642bc71b.png";